



















import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';
import StartCompanyItem from '@/views/StartCompanyItem.vue';
import StartSieItem from '@/views/StartSieItem.vue';
import StartDocumentItem from '@/views/StartDocumentItem.vue';
import StartWelcomeItem from '@/views/StartWelcomeItem.vue';
import {EventItem} from '@/store/models';
import {showWelcome, initialCompany} from '@/config';

@Component({
  components: {StartCompanyItem, StartSieItem, StartDocumentItem, StartWelcomeItem},
})
export default class Start extends Vue {
  async mounted() {
    if (user.companies && user.companies.length === 0 && initialCompany) {
      await user.addCompany(initialCompany);
    }
  }
  get events(): EventItem[] | null {
    return user.events;
  }
  get showWelcome() {
    return showWelcome;
  }
}
